$('#tabs-nav li:first-child').addClass('active');
$('.tab-content').hide();
$('.tab-content:first').show();


$('#tabs-nav li').click(function(){
  $('#tabs-nav li').removeClass('active');
  $(this).addClass('active');
  $('.tab-content').hide();
  
  var activeTab = $(this).find('a').attr('href');
  $(activeTab).fadeIn();
  return false;
});


$(document).ready(function(){
    $(".accor_heading").click(function(){
      $(this).toggleClass("active");
      $(this).siblings(".accor_decription").slideToggle();
    });
  });


$('.responsive').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [ 
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }
   
  ]
});

if($(window).width() <= 749){
$('.tabsslider').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1.2,
  slidesToScroll: 1
});
}



$('#tabs-navone li:first-child').addClass('active');
$('.tabsslider').hide();
$('.tabsslider:first').show();


$('#tabs-navone li').click(function(){
  $('#tabs-navone li').removeClass('active');
  $(this).addClass('active');
  $('.tabsslider').hide();
  
  var activeTab = $(this).find('a').attr('href');
  $(activeTab).fadeIn();
  if($(window).width() <= 749){
  $('.tabsslider').slick('refresh');
    };
  return false;
});




